import { render, staticRenderFns } from "./officePackage.vue?vue&type=template&id=2459f17a&"
import script from "./officePackage.vue?vue&type=script&lang=js&"
export * from "./officePackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2459f17a')) {
      api.createRecord('2459f17a', component.options)
    } else {
      api.reload('2459f17a', component.options)
    }
    module.hot.accept("./officePackage.vue?vue&type=template&id=2459f17a&", function () {
      api.rerender('2459f17a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/officePackage.vue"
export default component.exports